export const PROJECT_TYPES = {
  NEW_CONDO: "New Condo",
  ESTABLISHED_CONDO: "Established Condo",
};